import { Injectable } from '@angular/core';
import { SiteItemODataModel, TreeItemTypes } from '@common/models';
import { I18NextPipe } from 'angular-i18next';
import { I18_NAMESPACE_APPS_UI } from 'i18n';
import { TableHeader } from 'mbs-ui-kit';

interface TableHeaderResult {
  headers: TableHeader[];
  jumpToFile: boolean;
  showSizeColumn: boolean;
}

@Injectable()
export class SharePointTableHelperService {
  public readonly moduleDrive = I18_NAMESPACE_APPS_UI.drive;

  constructor(private i18nPipe: I18NextPipe) {}

  filterSiteItemByTreeItemType(siteItem: SiteItemODataModel): boolean {
    return [TreeItemTypes.SiteItem, TreeItemTypes.SiteBlock, TreeItemTypes.Root].includes(siteItem.TreeItemType) || !siteItem.Type;
  }

  getTableHeaders(customMode: boolean, searchTerm: string): TableHeaderResult {
    const jumpToFile = !!searchTerm;
    const showSizeColumn = customMode;

    const columns: TableHeader[] = [
      {
        name: this.i18nPipe.transform(this.moduleDrive + ':grid.type', { format: 'title' }),
        gridColMin: '63px',
        gridColSize: '63px',
        class: '-center',
        sort: showSizeColumn ? 'Type' : undefined
      },
      {
        name: this.i18nPipe.transform(this.moduleDrive + ':grid.name', { format: 'title' }),
        gridColMin: '150px',
        gridColSize: '20fr',
        overflow: true,
        class: 'text-overflow',
        sort: 'Name'
      }
    ];

    if (showSizeColumn) {
      columns.push({
        name: this.i18nPipe.transform(this.moduleDrive + ':grid.size', { format: 'title' }),
        gridColMin: '84px',
        gridColSize: '10fr',
        headerClass: '-right',
        class: 'text-overflow -right',
        sort: 'Size'
      });
    }

    if (jumpToFile) {
      columns.push({
        name: '',
        gridColMin: '46px',
        gridColSize: '46px',
        class: '-stretch'
      });
    }

    return { headers: columns, jumpToFile, showSizeColumn };
  }
}
